import {
  Component,
  Input,
  Output,
  EventEmitter,
  ContentChild,
  HostListener,
  ViewChild,
} from '@angular/core';
import { FeedPreset, PostsProvider } from '../../providers/posts/posts';
import * as _ from 'lodash';
import * as debug from 'debug';
import { ModalController } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';

/*
  Each Feed can have a refesher.  To create a feed and use the refresher:
  1. Add the ion-refresher elements on the first element insite the ion-content like this:
  <ion-content>
        <ion-refresher (ionRefresh)="feed && feed.refresh($event)">
          <ion-refresher-content> </ion-refresher-content>
        </ion-refresher>
  2. In the View create a property:
        @ViewChild('feed') feed: FeedComponent;
  3. Add the templete reference variable used on the ion-refresher like this:
      <feed #feed [feedPreset]="feedPreset?.All"></feed>

  */
@Component({
  selector: 'feed',
  templateUrl: 'feed.html',
})
export class FeedComponent {
  log = debug('app:FeedComponent');

  // Emits on New Records if this.loading === true
  @Output()
  loaded = new EventEmitter();

  @Output() changeActiveTab = new EventEmitter();

  @Input()
  feedPreset: FeedPreset;
  // Merged With query and feedOptions and passed to
  // this.postProvider.getFeed()
  @Input()
  query: any = {};
  @Input()
  feedOptions: any = {};
  // Template Structure Control
  @Input()
  contentMode = 'posts'; // or mediaGrid or liveChat
  // Post Loader Input
  @Input()
  checkHiddenContent = true;
  //Styling
  @Input()
  padding = true;
  @Input()
  maxRecords = Infinity;
  @Input()
  emptyIcon: String;
  @Input()
  emptyMessage = 'No posts available.';
  @Input()
  previewMode = false;
  // ability to get data provided in chunks
  @Input()
  chunkSize: number;

  chunks: any[] = [];
  records: any = [];
  media = [];

  @ContentChild('feedTemplate') feedTemplate;

  // @HostListener('document:filteredTags', ['$event.detail'])
  // updateFeed(detail) {
  //   this.createFeed({ filteredTags: detail });
  // }

  feed;
  subs = [];
  loading = true;
  refreshing = false;
  loadingId;
  feedClass = '';
  hideInfiniteScroll = false;
  infiniteScrollOn = false;
  vPromptOptions = {
    type: ['tall', 'short', 'drawer'],
    options: ['first', 'second'],
  };
  stopVpromptFn = false;
  vType: string = this.vPromptOptions.type[0];
  vOption: string = this.vPromptOptions.options[0];

  //ross
  liveChatGiveAway = false;
  lcGiveAwayConfig;
  //

  constructor(
    public postProvider: PostsProvider,
    public modalCtrl: ModalController,
    public configs: ConfigProvider
  ) {
    this.subs.push(
      this.configs.on('hashtagsUpdated', hashtags => {
        this.createFeed();
        this.log('hashtags | toggle', hashtags);
      })
    );
  }

  ngOnInit() {
    this.updateVerificationPrompt();
  }

  updateVerificationPrompt() {
    const vPromptData = localStorage.getItem('verificationPromptData');

    if (!vPromptData) return true;

    const parsedData = JSON.parse(vPromptData);
    const hiddenTime = parsedData.lastHidden;
    const previousOption = parsedData.vOption;
    const isGreaterThan24hrs = this.timeCheck(hiddenTime);

    if (isGreaterThan24hrs) {
      if (previousOption === 'first') {
        this.vOption = 'second';
      } else {
        this.vOption = 'first';
      }
      return true;
    }

    return false;
  }

  hideAndChangeVprompt() {
    if (!this.stopVpromptFn) {
      const vPromptData = localStorage.getItem('verificationPromptData');
      const nowInHours = Math.floor(new Date().getTime() / (1000 * 60 * 60));
      const promptData = {
        lastHidden: nowInHours,
        vOption: this.vOption,
      };
      this.stopVpromptFn = true;

      if (!vPromptData) {
        localStorage.setItem(
          'verificationPromptData',
          JSON.stringify(promptData)
        );
      } else {
        const parsedData = JSON.parse(vPromptData);
        const hiddenTime = parsedData.lastHidden;
        const isGreaterThan24hrs = this.timeCheck(hiddenTime);

        if (isGreaterThan24hrs) {
          localStorage.setItem(
            'verificationPromptData',
            JSON.stringify(promptData)
          );
        }
      }
    }
  }

  timeCheck(timeToCheck) {
    const currentTimeInHours = Math.floor(
      new Date().getTime() / (1000 * 60 * 60)
    );
    const timeDifference = currentTimeInHours - parseInt(timeToCheck, 10);
    const oneDayInHours = 24;

    if (timeDifference >= oneDayInHours) {
      return true;
    } else {
      return false;
    }
  }

  ngOnChanges() {
    this.loading = true;
    this.createFeed();
  }

  ngOnDestroy() {
    _.each(this.subs, s => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  openLiveChatPage() {
    this.changeActiveTab.emit({ id: 'liveChat', label: 'LiveChat' });
  }

  private createFeed(opts?: any) {
    opts = _.merge({
      ...opts,
      refresh: true,
    });

    const hashtagsSelected = _.compact(
      _.map(this.configs.get('hashtags'), t => t.selected && t.name)
    );

    if (hashtagsSelected && _.size(hashtagsSelected)) {
      this.log('createFeed | filteredTags', hashtagsSelected);
      this.query = _.merge({
        ...this.query,
        hashtags: hashtagsSelected,
      });
    } else {
      delete this.query.hashtags;
    }

    this.log('createFeed | query', this.query);

    return new Promise<void>((resolve, reject) => {
      const id = (this.loadingId = _.uniqueId());
      this.log('posts create feed', this.feedPreset);
      this.feedClass = _.get(this.feedOptions, 'class');
      this.hideInfiniteScroll = _.get(this.feedOptions, 'hideInfiniteScroll');
      this.feed = this.postProvider.getFeed(
        this.feedPreset,
        _.merge({ query: this.query }, this.feedOptions)
      );

      this.feed.on('loading', () => {});

      this.feed.on('doneLoading', () => {
        resolve();
      });

      this.feed.on('records', records => {
        resolve();
        if (opts.refresh) {
          opts.refresh = false;
          this.records = [];
          this.chunks = [];
        }
        this.log('new records', records);

        // otherwise, options were changed
        if (this.loading) {
          this.loaded.emit(true);
        }
        if (id === this.loadingId) {
          if (this.feedPreset === FeedPreset.UserActivity) {
            records = this.rollUpRecords(records);
            this.setLoadingComplete();
          }

          if (
            _.get(this.records, '0') !== _.get(records, '0') &&
            _.size(_.get(this, 'records'))
          ) {
            this.chunks = [];
            this.records = [records.shift()];
            this.pushChunk(this.records[0]);

            // next ticked because we don't want the DOM
            // rendering all at once
            _.each(records, r => {
              setTimeout(() => {
                if (this.records.length < this.maxRecords) {
                  this.records.push(r);
                  this.pushChunk(r);
                }
              });
            });
            this.setLoadingComplete();
          } else {
            for (let i = _.size(this.records); i < records.length; ++i) {
              setTimeout(() => {
                if (this.records.length < this.maxRecords) {
                  this.records.push(records[i]);
                  this.pushChunk(records[i]);
                }
              });
            }
            this.setLoadingComplete();
          }
          this.updateMedia(records);
        }
      });
    });
  }

  private updateMedia(records) {
    if (this.contentMode === 'mediaGrid') {
      this.media = [];
      records.forEach(p => {
        if (p && p.photoInformation && p.photoInformation.imageUrl) {
          this.media.push({
            post: p,
            type: 'PHOTO',
            info: p.photoInformation,
          });
        } else if (
          p &&
          p.photoInformation &&
          p.photoInformation.imageArray &&
          p.photoInformation.imageArray.length
        ) {
          p.photoInformation.imageArray.forEach(i => {
            this.media.push({
              post: p,
              type: 'PHOTO',
              info: i,
            });
          });
        } else if (p && p.videoInformation && p.videoInformation.videoUrl) {
          this.media.push({
            post: p,
            type: 'VIDEO',
            info: p.videoInformation,
          });
        }
      });
    }
  }

  private setLoadingComplete() {
    setTimeout(() => {
      this.loading = false;
    }, 20);
  }

  private rollUpRecords(records) {
    // the last n, and n = 5 is this:
    //
    // If the post was seen in the last n, roll it up into the previous viewing
    // if it was seen later than n, show it again
    const rs = [],
      n = 5,
      lastN = [];

    this.log('rolledUp start', records.length);

    _.each(records, d => {
      const thisPostId = _.get(d, 'parents.post._id') || d._id;
      let last, lastPostId;

      _.each(lastN, post => {
        lastPostId = _.get(post, 'parents.post._id') || _.get(post, '_id');

        if (lastPostId === thisPostId) {
          last = post;

          if (_.get(post, 'parents.post')) {
            last = post.parents.post;
          } else {
            last = post;
          }

          return false;
        }
      });

      let post;

      if (thisPostId === lastPostId) {
        post = last;
        _.pick(lastN, post);
        lastN.push(post);
      } else {
        if (_.get(d, 'parents.post')) {
          post = d.parents.post;
        } else {
          post = d;
        }
        lastN.push(d);
        if (lastN.length > n) {
          lastN.shift();
        }
      }

      post.engagements = post.engagements || [];
      post.engagementLookup = post.engagementLookup || {};

      if (_.get(d, 'parents.post')) {
        if (!post.engagementLookup[d._id]) {
          post.engagements.push(d);
          post.postEngagementUsers = post.postEngagementUsers || [];
          post.postEngagementUsers.push(d.user);
          post.postEngagementUsers = _.uniqBy(post.postEngagementUsers, '_id');
          post.postEngagementUser = d.user;
          post.engagementLookup[d._id] = true;
        }
      }

      if (_.get(d, 'parents.comment')) {
        const c = _.get(d, 'parents.comment');
        if (!post.engagementLookup[c._id]) {
          post.engagements.push(c);
          post.engagementLookup[c._id] = true;
        }
      }

      if (thisPostId !== lastPostId) {
        // not already in the list
        rs.push(post);
      } else {
        last.postEngagementUsers = last.postEngagementUsers || [];
        last.postEngagementUsers.push(d.user);
        last.postEngagementUsers = _.uniqBy(post.postEngagementUsers, '_id');
      }
    });

    this.log('rolled up records %d', rs.length, rs);

    return rs;
  }

  doInfinite(infiniteScroll) {
    if (!this.infiniteScrollOn) {
      this.infiniteScrollOn = true;
      this.feed.loadData().then(() => {
        infiniteScroll.complete();
        this.infiniteScrollOn = false;
      });
    }
  }

  async refresh(refresher) {
    this.loading = true;
    this.refreshing = true;
    await this.createFeed({
      refresh: true,
    });
    refresher.complete();
  }

  postModal(post) {
    this.log('creating post modal', post);

    const modal = this.modalCtrl.create('CommunityPostsPage', {
      post: post,
    });

    modal.present();
  }

  hidePost(post) {
    this.log('hide post');
    _.remove(this.records, post);
  }

  blockUser(post) {
    const userId = _.get(post, 'user._id');
    _.forEach(this.records, p => {
      if (_.get(p, 'user._id') === userId) {
        _.remove(this.records, p);
      }
    });
  }

  private pushChunk(record) {
    if (!this.chunkSize) return;

    let activeChunk = this.chunks[this.chunks.length - 1];

    // no chunks yet => start it up
    if (!activeChunk) {
      this.chunks.push((activeChunk = []));
    }

    if (activeChunk.length === this.chunkSize) {
      this.chunks.push((activeChunk = []));
    }

    activeChunk.push(record);
  }
}



// WEBPACK FOOTER //
// ./src/components/feed/feed.ts